export default __webpack_public_path__ + "static/1017-11c4547423056aeec7551ee7b743b1c2.gif";